import React, { useState, useEffect, useCallback, useRef } from 'react'
import { getSession } from '../../getSession'
import { getSequence, sendMassSequenceNew } from '../../utils/lead'
import Swal from 'sweetalert2'

const MarkettingSequence = ({
  onClose = () => {},
  onSave = (payload) => {},
  sequences = [],
  initial = {},
  selectedCount = 0,
  selectedLeadIds = [],
  hashedIds = '',
  massOpBatchId = '',
  applyOnAllLeads = false,
  registerSubmitHandler
}) => {
  const [sequenceId, setSequenceId] = useState(initial.sequenceId || '')
  const [schedule, setSchedule] = useState(initial.schedule || false)
                                                                                                      const [scheduleAt, setScheduleAt] = useState(initial.scheduleAt || '')
                                                                                                      const [error, setError] = useState('')
  const [seqOptions, setSeqOptions] = useState(sequences && sequences.length ? sequences : [])

  const validate = () => {
    setError('')
    if (!sequenceId) { setError('Please select a sequence'); return false }
    if (schedule && !scheduleAt) { setError('Schedule date/time is required when scheduling'); return false }
    return true
  }

  const handleSaveRef = useRef(null)

  const handleSave = useCallback(async () => {
    if (!validate()) return

    const { userId, TokenId } = getSession()
    const numericUserId = Number(userId) || 0
    const numericBatchId = Number(massOpBatchId) || 0
    const idsFromSelection = (hashedIds || (Array.isArray(selectedLeadIds) ? selectedLeadIds.join('/') : '') || '').trim()
    const shouldUseBatchId = !!applyOnAllLeads && numericBatchId > 0
    const idsForPayload = shouldUseBatchId ? '' : idsFromSelection

    if (!sequenceId || (!shouldUseBatchId && !idsForPayload)) {
      setError('Please select sequence and leads.');
      return;
    }

    const payload = {
      Token: TokenId,
      Message: '',
      LoggedUserId: numericUserId,
      MAC_Address: '',
      IP_Address: '',
      Details: {
        IDS: idsForPayload,
        Userid: numericUserId,
        massbatchid: shouldUseBatchId ? numericBatchId : 0,
        SequenceId: Number(sequenceId),
        SequenceName: seqOptions.find(s => String(s.id) === String(sequenceId))?.name || '',
        StartDateTime: schedule ? (scheduleAt || '') : '',
        SequenceType: 'Lead'
      },
      BroadcastName: ''
    }

    try {
      const resp = await sendMassSequenceNew(payload)
      const status = Number(resp?.Status ?? resp?.status ?? 0)
      const details = resp?.Details
      const detailMessage = typeof details === 'string'
        ? details
        : (Array.isArray(details)
          ? (details[0]?.Result || details[0]?.Message || '')
          : (details?.Result || details?.Message || ''))

      if (status === 1) {
        Swal.fire({ icon: 'success', title: 'Success', text: 'Sequence added successfully.' })
        onSave(payload)
        onClose()
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: detailMessage || resp?.Message || 'Failed to add sequence.' })
      }
    } catch (err) {
      console.error('send mass sequence error', err)
      Swal.fire({ icon: 'error', title: 'Error', text: 'An error occurred while adding sequence.' })
    }
  }, [
    sequenceId,
    schedule,
    scheduleAt,
    selectedLeadIds,
    hashedIds,
    massOpBatchId,
    applyOnAllLeads,
    onClose,
    onSave,
    seqOptions
  ])

  useEffect(() => {
    handleSaveRef.current = handleSave
  }, [handleSave])

  useEffect(() => {
    if (typeof registerSubmitHandler === 'function') {
      registerSubmitHandler(() => () => handleSaveRef.current?.())
      return () => registerSubmitHandler(null)
    }
  }, [registerSubmitHandler])

  useEffect(() => {
    if (sequences && sequences.length) {
      setSeqOptions(sequences)
      if (!sequenceId) setSequenceId(sequences[0].id)
      return
    }

    let mounted = true
    const fetchSeq = async () => {
      try {
        const { userId, TokenId } = getSession()
        const payload = {
          Token: TokenId,
          Message: '',
          LoggedUserId: userId,
          MAC_Address: '',
          IP_Address: '',
          Details: { UserId: userId },
          BroadcastName: ''
        }
        const resp = await getSequence(payload)
        let list = resp ?? []
        if (list && list.data) list = list.data
        if (list && !Array.isArray(list)) list = list.ResultList ?? list.Items ?? list.Data ?? list.Details ?? list

        const opts = Array.isArray(list) ? list.map(item => {
          if (!item) return null
          const id = item.SequenceID ?? item.SequenceId ?? item.SequenceId ?? item.id ?? item.SequenceID
          const name = item.SequenceName ?? item.Name ?? item.Text ?? item.SequenceName
          return id ? { id: String(id), name: String(name ?? id) } : null
        }).filter(Boolean) : []

        if (mounted && opts.length) {
          setSeqOptions(opts)
          if (!sequenceId) setSequenceId(opts[0].id)
        }
      } catch (err) {
        console.warn('Failed to load sequences', err?.message || err)
      }
    }
    fetchSeq()
    return () => { mounted = false }
  }, [sequences])

  return (
    <div className="w-full max-w-xl">
      <div className="mb-3 text-sm text-blue-800 bg-blue-50 border border-blue-100 p-2 rounded">Info! You are about to perform a mass action on {selectedCount} selected record(s)</div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Select Sequence <span className="text-red-600">*</span></label>
          <select value={sequenceId} onChange={e => setSequenceId(e.target.value)} className="w-full border px-3 py-2 rounded">
            <option value="">--Select Sequence--</option>
            {seqOptions.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>




        <div className="flex items-center justify-between">
          <label className="inline-flex items-center">
            <input type="checkbox" checked={schedule} onChange={() => setSchedule(s => !s)} className="rounded-[3px] mr-2" />
            On Schedule Date And Time
          </label>
        </div>

        {error && <div className="text-red-600 text-sm">{error}</div>}

        {schedule && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Schedule Date and Time</label>
            <input type="datetime-local" value={scheduleAt} onChange={e => setScheduleAt(e.target.value)} className="w-full border px-3 py-2 rounded" />
          </div>
        )}
      </div>
    </div>
  )
}

export default MarkettingSequence
